<template>
    <div class="container-fluid w-100 h-100" style="overflow-x: hidden">
        <navbar :title="$t('tracking_devices.title')" class="mb-1"/>
        <tracking-device-list
            v-if="!editMode"
            :results="results"
            @add="addTrackingDevice"
            @edit="editTrackingDevice"
        />

        <base-modal v-if="editMode" hide-footer hide-header @close="showList" size="lg">
            <tracking-device-editor
                :device="device"
                @close="showList"
                @close-and-update="closeAndUpdate"
            />
        </base-modal>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import TrackingDeviceList from './TrackingDeviceList'
import TrackingDeviceEditor from './TrackingDeviceEditor'
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'TrackingDevices',
    components: {BaseModal, Navbar, TrackingDeviceList, TrackingDeviceEditor},
    mixins: [restApi, workManagementHelper],
    data: function () {
        return {
            results: [],
            device: null,
            editMode: false,
            loading: false,
        }
    },
    mounted: function () {
        this.fetchTrackingDevices()
    },
    methods: {
        fetchTrackingDevices: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.trackingDeviceUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            if (response && response.data) {
                this.results = response.data
            }
            this.loading = false
        },
        addTrackingDevice: function () {
            this.device = {imei: undefined, vehicle: undefined, user: undefined, harja_enabled: true}
            this.editMode = true
        },
        editTrackingDevice: function (device) {
            this.device = device
            this.editMode = true
        },
        showList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchTrackingDevices()
            this.showList()
        }

    }
}
</script>
